import { z } from 'zod'

export const crosssellTypesSchema = z.enum([
  'zubehoer',
  'serie',
  'alternativen',
  'ergaenzung',
])